import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/antd.css';
import '@babel/polyfill'
import 'core-js'
import 'mutation-observer'
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import setprototypeof from 'setprototypeof';
import Maintenance from './components/Maintenance';

Object.setPrototypeOf = setprototypeof;

// ============= 维护模式开关 =============
// true  = 显示维护页面
// false = 正常运行（默认）
const MAINTENANCE_MODE = true;
// =======================================

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );
ReactDOM.render(
  MAINTENANCE_MODE ? <Maintenance /> : <App />,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
